import { render, staticRenderFns } from "./BooleanGroup.vue?vue&type=template&id=1b52ea17&"
import script from "./BooleanGroup.vue?vue&type=script&lang=ts&"
export * from "./BooleanGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports